// src/mismatch.ts
import { DateTime } from "luxon";
var MISMATCH_THRESHOLD = 0.05;
var comparePeriod = (indexConsumption, telemetryConsumption) => {
  const delta = indexConsumption - telemetryConsumption;
  return {
    indexConsumption,
    telemetryConsumption,
    delta,
    isFlagged: indexConsumption > 0 && Math.abs(delta) / indexConsumption > MISMATCH_THRESHOLD
  };
};
var computeMismatchPeriods = (readings, telemetryDatapoints) => {
  if (readings.length < 2) return {};
  const sorted = [...readings].sort((a, b) => new Date(a.readingAt).getTime() - new Date(b.readingAt).getTime());
  const stamps = telemetryDatapoints.map((dp) => ({
    at: DateTime.fromISO(dp.dateTime),
    consumption: dp.consumption ?? 0
  }));
  return sorted.slice(1).reduce((acc, readingB, i) => {
    const readingA = sorted[i];
    const startDt = DateTime.fromISO(readingA.readingAt);
    const endDt = DateTime.fromISO(readingB.readingAt);
    const dayCount = Math.ceil(endDt.diff(startDt, "days").days);
    if (dayCount <= 0) return acc;
    const telemetryConsumption = stamps.filter((stamp) => stamp.at >= startDt && stamp.at < endDt).reduce((sum, stamp) => sum + stamp.consumption, 0);
    const comparison = comparePeriod(readingB.value - readingA.value, telemetryConsumption);
    return {
      ...acc,
      [readingB.id]: {
        ...comparison,
        readingA,
        readingB,
        dailyCorrection: Math.round(comparison.delta / dayCount * 100) / 100,
        dayCount
      }
    };
  }, {});
};
var SCALE_TOLERANCE = 0.2;
var looksLikeScaleError = (period) => {
  if (period.telemetryConsumption === 0 || period.indexConsumption === 0) return false;
  const ratio = period.indexConsumption / period.telemetryConsumption;
  return [10, 0.1].some((factor) => Math.abs(ratio - factor) / factor <= SCALE_TOLERANCE);
};
export {
  MISMATCH_THRESHOLD,
  comparePeriod,
  computeMismatchPeriods,
  looksLikeScaleError
};
//# sourceMappingURL=index.js.map